interface WorkspaceTourVideoPlayerProps {
  src: string
  poster?: string
  className?: string
}

export const WorkspaceTourVideoPlayer = ({ src, poster, className }: WorkspaceTourVideoPlayerProps) => {
  return (
    <video
      src={src}
      poster={poster}
      controls
      controlsList="nodownload"
      playsInline
      className={className}
    />
  )
}
